import React, { useEffect, useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import Script from "next/script";

const NLModule = ({ blok }) => {
  const [successBox, setSuccessBox] = useState("none");

  const createFormNl = () => {
    Formio.createForm(
      document.getElementById("newsletterForm"),
      "https://forms.erfolgreichgastro.de/#/form/63fcb6da16056f5e5acb9a0e/"
    ).then(function (form) {
      form.on("submit", function (submission) {
        showSuccessBox();
      });
    });
  };

  /*   useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.form.io/formiojs/formio.form.min.js";
    script.onload = createFormNl;
    document.body.appendChild(script);
  }, []); */

  useEffect(() => {
    createFormNl();
  }, []);

  function showSuccessBox() {
    setSuccessBox("flex");
  }

  function newSubmit() {
    location.reload();
  }

  return (
    <div className="nl-wrap" {...storyblokEditable(blok)}>
      <div className="nl-content-outer">
        <div className="nl-content">
          <h2 className="nl-subheadline text-5xl">{blok.subheadline}</h2>
          <h2 className="nl-subheadlineTwo text-5xl">{blok.subheadline2}</h2>
          <h2 className="nl-subheadlineThree text-5xl">{blok.subheadline3}</h2>
          

          <p className="infotext">{blok.infotext}</p>
          <p className="infotext">{blok.infotext2}</p>

          {/*   <div className='nl-input'>
             <input type="e-mail" placeholder='Email-Adresse' />
        <button>Anmelden</button>
        </div>
       
        <p>Ich habe die <a href="#">Datenschutzbestimmungen</a>zur Kenntnis genommen und stimmte der Nutzung meiner Daten zu Marketingzwecken zu.</p> */}
        </div>

        <div className="newsletter-form-box">
          <div id="newsletterForm"></div>
          <div style={{ display: `${successBox}` }} className="success-box-nl">
            <div>
              <p>Vielen Dank für Ihre Anmeldung zu unserem Newsletter.</p>
              <button onClick={newSubmit}>Erneut anmelden</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NLModule;
